import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { login as apiLogin, getMe } from '../api/auth';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [adminRole, setAdminRole] = useState(null);
  const [permissions, setPermissions] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('nula_admin_token');
    if (!token) {
      setLoading(false);
      return;
    }
    getMe()
      .then((res) => {
        if (res.data.user.user_role !== 'admin') {
          localStorage.removeItem('nula_admin_token');
          setUser(null);
          setAdminRole(null);
          setPermissions(null);
        } else {
          setUser(res.data.user);
          setAdminRole(res.data.adminRole || null);
          setPermissions(res.data.permissions || null);
        }
      })
      .catch(() => {
        localStorage.removeItem('nula_admin_token');
        setUser(null);
        setAdminRole(null);
        setPermissions(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const res = await apiLogin(email, password);
    const { token, user: userData } = res.data;

    if (userData.user_role !== 'admin') {
      throw new Error('Access denied. Admin accounts only.');
    }

    localStorage.setItem('nula_admin_token', token);
    setUser(userData);

    try {
      const meRes = await getMe();
      setAdminRole(meRes.data.adminRole || null);
      setPermissions(meRes.data.permissions || null);
    } catch (_) {
      setAdminRole(null);
      setPermissions(null);
    }

    return userData;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('nula_admin_token');
    setUser(null);
    setAdminRole(null);
    setPermissions(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, adminRole, permissions, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
